import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, Validators, FormGroup } from '@angular/forms';
import { GenericModal } from '../modals/generic-modal/generic-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { RequestService } from '../../services/request.service';
import { ComponentService } from '../../services/component.service';
import { LibService } from '../../services/libService';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-request-customer-contacted-button',
  templateUrl: './request-customer-contacted-button.component.html',
  styleUrls: ['./request-customer-contacted-button.component.scss']
})
export class RequestCustomerContactedButtonComponent implements OnInit {

  @Input() form: FormGroup;
  @Input() isNew: any;
  @Input() components: any;
  @Input() documents: any;

  attributes: any;

  actions: any = [];

  componentName: any = 'request_customer_contacted_button'


  constructor(
    private dialog: MatDialog,
    private requestService: RequestService,
    private componentService: ComponentService,
    private router: Router,
    private libService: LibService
  ) { }

  customerContacted(attributes: any) {
    this.libService.lockPage('');
    let id = this.form.get('id')?.value
    this.requestService.customerContacted(id, attributes).subscribe(
      (res: any) => {
        console.log(res)
        this.router.navigate(['request/' + id]).then(_res => {
          window.location.reload()
        })
      },
      (err: any) => {
        console.log(err)
        this.libService.unlockPage();
      },
    )
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  disabled(){
    // Non è disabilitato se il form non è modificato ed è valido
    let disabled = true;
    if(!this.form.dirty && this.form.valid) disabled = false;
    return disabled;
    
  }

  ngOnInit(): void {
    console.log('ngOnInit request close button')
    this.setActions()

  }

  openModal() {
    const dialogRef = this.dialog.open(GenericModal, {
      width: '400px',
      data: {
        actions: this.actions,
        titleLabel: 'REQUEST.clienteContattato',
        textLabel: 'REQUEST.testoContattaCliente',
        confirmButtonLabel: 'LABEL.SAVE',
        cancelButtonLabel: 'LABEL.CANCEL',
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);

      if (![null, undefined].includes(result)) {
        let attributes = result;
        attributes.attributeCode = this.componentName
        attributes.esit = 'changeOfState'
        this.customerContacted(attributes)
      }

    });


  }

  getAttributes(componentCode: any) {
    let component = this.components?.settings?.find((component: any) => component.componentCode == componentCode)
    return component?.attributes
  }

  checkNecessaryDocuments() {
    //console.log('checkNecessaryDocuments - request_customer_contacted_button')
    let key = 'request_document_manager'
    if (!this.checkComponentFast(key)) key = 'crmDocumentManager'
    let attributes = this.getAttributes(key)
    return this.componentService.checkDocumentsStatus(key, attributes, this.form, this.documents)
  }

  setActions() {
    this.setAttributes()
    if (this.attributes) {
      this.actions = []
      let structure: any = this.componentService.getStructure(this.attributes)
      structure.forEach((s: any) => {
        if (s.type == 'action' && !this.actions.includes(s.type)) this.actions.push(s.code)
      })
      //console.log(this.actions)
    }
  }

  setAttributes() {
    //console.log('setAttributes')
    let component = this.components?.settings?.find((component: any) => component.componentCode == this.componentName)
    this.attributes = component?.attributes
  }

  checkComponentFast(componentName: any = null) {
    let key = componentName || this.componentName
    let status = this.components?.codes?.includes(key)
    return status
  }

  checkComponent(componentName: any = null) {
    let key = componentName || this.componentName
    let status = this.components?.codes?.includes(key)
    if (status) {
      this.setAttributes()
      this.setActions()
    }
    return status
  }

}
